import { LocalizationService } from "../localization/localization.service";
import { Injectable } from "@angular/core";
import * as moment from "moment";

@Injectable()
export class DateService {
    constructor(private localizationService: LocalizationService) {}

    public getFullDate(dateTime: string): string | null{
        return moment(dateTime).format('YYYY.MM.DD');
    }

    public getFullDateTime(dateTime: string): string | null{
        return moment(dateTime).format('YYYY.MM.DD HH:mm:ss');
    }

    public getFullDateWithDay(dateTime: string): string | null{
        return moment(dateTime).format('ddd YYYY.MM.DD');
    }

    public getTime(dateTime: string): string | null{
        return moment(dateTime).format('HH:mm');
    }

    public getDay(dateTime: string): string | null{
        moment.locale(this.localizationService.getLanguage());
        return moment(dateTime).format('ddd');
    }

    public getDate(dateTime: string): string | null{
        return moment(dateTime).format('M-DD');
    }
}